import React from 'react'
import {Helmet} from 'react-helmet'
import {useNonce} from '../hooks'
import useOcapiSite from '../hooks/useOcapiSite'

const Klaviyo = () => {
    const nonce = useNonce()
    const ocapiSite = useOcapiSite()
    const klaviyoKey = ocapiSite.preferences.klaviyoKey || 'RmU9Jq'
    const klaviyoResource = `//static.klaviyo.com/onsite/js/${klaviyoKey}/klaviyo.js`

    return (
        <Helmet>
            <script async src={klaviyoResource} nonce={nonce} />
        </Helmet>
    )
}

export default Klaviyo
